// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2_9gO","name":"ConsentHeader_name__17ZfV","birthday":"ConsentHeader_birthday__y9Qy6","skeleton":"ConsentHeader_skeleton__33zx_"};